import { render, staticRenderFns } from "./RematchOfferStep.vue?vue&type=template&id=2913880f"
import script from "./RematchOfferStep.vue?vue&type=script&lang=js"
export * from "./RematchOfferStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports